// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ClickableRowController from './clickable_row_controller'
import ConfirmableFormController from './confirmable_form_controller'
import ModalLauncherController from './modal_launcher_controller'
import ModalController from './modal_controller'
import NavController from './nav_controller'
import PagyInitializerController from './pagy_initializer_controller'
import BrandBannerController from './brand_banner_controller'
import QueryStringsController from './query_strings_controller'

application.register('confirmableForm', ConfirmableFormController)
application.register('modalLauncher', ModalLauncherController)
application.register('modal', ModalController)
application.register('nav', NavController)
application.register('pagyInitializer', PagyInitializerController)
application.register('clickableRow', ClickableRowController)
application.register('brand-banner', BrandBannerController)
application.register('query-strings', QueryStringsController)
